import styled, { css } from 'styled-components'

import { DEFAULT_CONTAINER_PADDING } from '@/common/constants'

export const Container = styled.div<{ useShadow?: boolean }>`
  display: inline-block;
  position: relative;
  padding: ${DEFAULT_CONTAINER_PADDING}px;
  width: 100%;
  max-width: var(--card-max-width);
  min-height: 60px;
  border-radius: var(--card-border-radius);
  background-color: var(--card-background-color);
  color: var(--card-text-color);
  ${({ useShadow = true }) => css`
    box-shadow: ${useShadow ? `var(--card-box-shadow)` : 'none'};
  `}
`
